var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.742 0.917989C79.7259 0.349937 80.9381 0.349934 81.922 0.917987L147.591 38.832C148.575 39.4001 149.181 40.4499 149.181 41.586V117.414C149.181 118.55 148.575 119.6 147.591 120.168L81.922 158.082C80.9381 158.65 79.7259 158.65 78.742 158.082L13.073 120.168C12.0891 119.6 11.483 118.55 11.483 117.414V41.586C11.483 40.4499 12.0891 39.4001 13.073 38.832L78.742 0.917989Z",
    fill: "#CDB972"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_5037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5002 63.1669L55.3889 47.4671L55.4087 47.4443H75.1724L61.5002 63.1669ZM52.5556 50.5992L41.5594 63.2443H57.4779L52.5556 50.5992ZM66.4991 63.2443H94.2065L80.4675 47.4443H80.2387L66.4991 63.2443ZM105.385 47.5446L105.298 47.4443H85.5332L99.2576 63.2276L105.385 47.5446ZM119.147 63.2443L108.217 50.6748L103.306 63.2443H119.147ZM101.813 67.1943L84.8933 110.502L119.246 67.1943H101.813ZM41.4609 67.1943L75.8347 110.532L58.9655 67.1943H41.4609ZM80.3335 111.556L97.7089 67.1943H63.0671L80.3335 111.556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_5037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    fill: "white",
    transform: "translate(40.832 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondBrown);
export default __webpack_public_path__ + "static/media/diamond-brown.c1e4dc7c5522e2c5bee906ec6423b041.svg";
export { ForwardRef as ReactComponent };